import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const presentationMembershipApi = generateNomenApi(`/presentation/presentation-membership`);

export const presentationMembershipOptions = generateNomenOptions('presentation-membership', presentationMembershipApi);
